import React, {Component} from 'react';
import PrintTwoPagesDoc from './PrintTwoPagesDoc';

class PrintTwoPagesInvoiceDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {}

  }

  componentDidMount(){

  }

  render() {
    return(
      <PrintTwoPagesDoc
        title={'ใบแจ้งหนี้'} 
        doc={'invoice_doc'}
        docNo={this.props.ivNo}
        param={'iv'}
      >
      </PrintTwoPagesDoc>
    )
  }
}  

export default PrintTwoPagesInvoiceDoc;


// WEBPACK FOOTER //
// ./src/view/print/PrintTwoPagesInvoiceDoc.js